// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopSupplierByIdRequestModel from '../../model/delete-shop-supplier-by-id-request-model';
import DeleteShopSupplierByIdRequestDTO from '../dto/delete-shop-supplier-by-id-request-dto';
import dtoSchema from '../schemas/delete-shop-supplier-by-id-request-schema';

export default abstract class DeleteShopSupplierByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopSupplierByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopSupplierByIdRequestDTO>): DeleteShopSupplierByIdRequestModel;
  static toModel(dto: DeepPartial<DeleteShopSupplierByIdRequestDTO> | undefined | null): DeleteShopSupplierByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopSupplierByIdRequestDTO> | undefined | null): DeleteShopSupplierByIdRequestModel | undefined {
    return dto ? new DeleteShopSupplierByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopSupplierByIdRequestModel> | DeleteShopSupplierByIdRequestModel): DeleteShopSupplierByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopSupplierByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopSupplierByIdRequestModel, can not map to DeleteShopSupplierByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
